export {}

declare global {
  interface String {
    startsWith(substring: string);
    endsWith(substring: string);
    caseInsensitiveCompare(other: string);
    regExpEscape();
    toCapitalized();
    toTitleCase();
    padStart(targetLength: number, padString: string);
  }
}

String.prototype.startsWith = function(this: string, substring: string) {
  return this.slice(0, substring.length) === substring;
}

String.prototype.endsWith = function(this: string, substring: string) {
  return substring === '' || this.slice(-substring.length) === substring;
}

String.prototype.caseInsensitiveCompare = function(this: string, other: string) {
  return this.toLowerCase() === other.toLowerCase();
}

// Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
String.prototype.regExpEscape = function(this: string) {
  return this.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

String.prototype.toCapitalized = function(this: string) {
   return this.charAt(0).toUpperCase() + this.slice(1);
}

String.prototype.toTitleCase = function(this: string) {
  let isAcronym = (x) => ['tv', 'abc', 'xd'].find((a) => x === a) != null;
  let isNumeral = (x) => x.replace(/[xiv]/g, '') === '';
  let regex = /[\w']+/g;
  let string = '';
  let match;
  let i = 0;
  while ((match = regex.exec(this.toLowerCase())) != null) {
    let word = match[0];
    if (match.index != i) {
      string += this.substr(i,match.index-i);
      i = match.index;
    }
    if (word.length < 5 && (isAcronym(word) || isNumeral(word))) {
      word = word.toUpperCase();
    } else {
      word = word.toCapitalized();
    }
    string += word;
    i += word.length;
  }
  if (string.length < this.length) {
    string += this.substr(i,this.length-i);
  }
  return string;
}

// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength,padString) {
        targetLength = targetLength>>0; //floor if number or convert non-number to 0;
        padString = String(padString || ' ');
        if (this.length > targetLength) {
            return String(this);
        }
        else {
            targetLength = targetLength-this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength/padString.length); //append to original to ensure we are longer than needed
            }
            return padString.slice(0,targetLength) + String(this);
        }
    };
}


// WEBPACK FOOTER //
// ./src/app/extensions/string.extension.ts